import { useCallback } from 'react'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../baseComponents/Modal'
import { RowData } from '../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { BeforeSubmitHandler, OnSubmit } from '../../../../../../forms/TwinForm/types'
import { SetEditDeleteModalTy } from '../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { twinFetchPostPrinter } from '../../../../../../utils/globals/data'
import TwinForm from '../../../../../../forms/TwinForm'
import { InputHidden, InputWithLabelMarginIntegerStateFull } from '../../../../../../forms/Input'
import useIsLoading from '../../../../../../utils/hooks/useIsLoading'


interface ModalWorkSheetSellTagProps extends ModalWorkSheetSellTagLogicProps {
}

const ModalWorkSheetSellTag: React.FC<ModalWorkSheetSellTagProps> = ({ ...logic }) => {
    const { t } = useTwinTranslation()
    const { mySetOpened, loading, myOnSubmit, onPreSubmit } = useModalWorkSheetSellTagLogic({ ...logic })
    return (
        <ModalSmallCentered opened={true} setOpened={() => logic.setOpenModal(null)} onClickOut={false} className='skip_width_fields'>
            <TwinForm beforeSubmitHandler={onPreSubmit} action={'/api/app/order/sell/workSheet/printWorkSheetLabels'} onSubmit={myOnSubmit} className='flex flex-auto flex-col justify-between ' triggerErrors={false} triggerSuccess={false}>
                <h2 className='mb-20'>
                    <TwinTrans transKey={'statusHasAssociatedSellTag'}>Este estado tiene una etiqueta asociada</TwinTrans>
                </h2>
                <span className='mt-10 mb-30'><TwinTrans transKey={'doYouWantToPrintTags'}>¿Quieres imprimir las etiquetas?</TwinTrans></span>
                <InputWithLabelMarginIntegerStateFull className='text-start mb-20' label={t('tagQuantity', 'Cantidad de etiquetas')} minValue={1} defaultValue={String(logic.allRowData?.tagQuantity)} name='tagQuantity' />
                <InputHidden name='id' value={logic.allRowData?.id}/>
                <InputHidden name='LabelId' value={logic.allRowData?.LabelId}/>
                <InputHidden name='SpecificPriceRuleId' value={logic.allRowData?.SpecificPriceRuleId}/>
                <ButtonsModalSmallCentered confirmText={t('print', 'Imprimir')} setOpened={() => { }} onCancel={mySetOpened} loading={loading}/>
            </TwinForm>
        </ModalSmallCentered>
    )
}

interface ModalWorkSheetSellTagLogicProps {
    allRowData: RowData
    setOpenModal: SetEditDeleteModalTy
    onSubmit: OnSubmit
}

const useModalWorkSheetSellTagLogic = ({ setOpenModal, allRowData, onSubmit }: ModalWorkSheetSellTagLogicProps) => {
    const { startLoading, endLoading, loading } = useIsLoading()
    const {t} = useTwinTranslation()
    const errorMessage = t('couldNotConnectWithPrinter', 'No se ha podido conectar con la impresora')
    const onPreSubmit: BeforeSubmitHandler = useCallback((vals) => {
        vals.extraProductsWhere = {id: allRowData.WorkSheetProductId}
        startLoading()
        return true
    }, [startLoading, allRowData.WorkSheetProductId])
    
    const mySetOpened = useCallback(() => {
        if (allRowData?.extraParamsForMatch && Object.keys(allRowData?.extraParamsForMatch).length) {
            setOpenModal({ type: 'edit', allRowData: { ...allRowData.extraParamsForMatch } })
        } else {
            onSubmit?.(false as any, {})
            setOpenModal(null)
        }
    }, [setOpenModal, allRowData, onSubmit])

    const myOnSubmit: OnSubmit = useCallback(async (result) => {
        if (result && result.status === 367) {
            const body = await result.json()
            const myresult = await twinFetchPostPrinter('/printLabel', body, errorMessage)
            if (myresult) {
                mySetOpened()
            }
        }
        endLoading()
    }, [endLoading, mySetOpened, errorMessage])
    return { mySetOpened, myOnSubmit, onPreSubmit, loading }
}

export default ModalWorkSheetSellTag